import * as actions from "Actions";
import * as api from "Api";
import { pushSourceToken } from "Utils";

export const fetchDashboards = ({ limit, clientUEN = null }) => {
  return (dispatch, getState) => {
    let sourceToken = pushSourceToken("FETCH_DASHBOARDS", dispatch);

    const { auth } = getState();
    const { token, navCommunity } = auth;

    return dispatch(
      actions.fetchDashboards(
        api.getDashboards({
          token,
          limit,
          communityId: navCommunity ? navCommunity.id : null,
          clientUEN,
          sourceToken
        })
      )
    );
  };
};

export const fetchInfiniteDashboards = ({
  limit = 20,
  offset = 0,
  clientUEN = null
}) => {
  return (dispatch, getState) => {
    const { auth } = getState();
    const { token, navCommunity } = auth;

    return dispatch(
      actions.fetchInfiniteDashboards(
        api.getDashboards({
          token,
          limit,
          offset,
          communityId: navCommunity ? navCommunity.id : null,
          clientUEN
        })
      )
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/dashboard.js